<template>
  <header class="header">
    <div class="head">
      <img class="logo" :src="logo" />
      <div class="head-left">
        <div class="nav">
          <p class="head-text" @click="scrollbar(0)">{{ home }}</p>
        </div>
        <div class="nav">
          <p class="head-text" @click="scrollbar(450)">{{ about }}</p>
        </div>
        <div class="nav">
          <p class="head-text" @click="scrollbar(1400)">{{ family }}</p>
        </div>
        <div class="nav">
          <p class="head-text" @click="scrollbar(2900)">{{ team }}</p>
        </div>
        <div class="nav">
          <p class="head-text" @click="scrollbar(6200)">加入知春</p>
        </div>
        <div class="nav">
          <p class="head-text" @click="scrollbar(10000)">{{ telus }}</p>
        </div>
      </div>
      <!--
      <div
        class="btn"
        :style="{
          backgroundImage:
            language == '中文' ? `url(${zhlogo})` : `url(${enlogo})`
        }"
      >
        <div class="zh" @click="changeTab('中文')"></div>
        <div class="en" @click="changeTab('英文')"></div>
      </div>
      -->
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      logo: require("../assets/logo.png"),
      headlogo: require("../assets/headlogo.jpg"),
      zhlogo: require("../assets/zh.png"),
      enlogo: require("../assets/en.png")
    };
  },
  mounted() {},
  computed: {
    ...mapGetters({
      language: "getType"
    }),
    home() {
      return this.language == "中文" ? "主页" : "Home";
    },
    about() {
      return this.language == "中文" ? "关于我们 " : "About Atlas";
    },
    team() {
      return this.language == "中文" ? "投资团队" : "Our Team";
    },
    family() {
      return this.language == "中文" ? "成员企业 " : "Atlas Family";
    },
    telus() {
      return this.language == "中文" ? "联系我们" : "Contacts";
    }
  },
  methods: {
    ...mapMutations(["changelanguage"]),
    scrollbar(value) {
      window.scrollTo({
        top: value,
        behavior: "smooth"
      });
    },
    changeTab(value) {
      if (this.language == value) {
        return;
      }
      this.changelanguage(value);
    }
  }
};
</script>

<style lang="less" scoped>
.btn {
  width: 160/1.3px;
  height: 42/1.3px;
  //background: url("../assets/zh.png");
  background-size: 100% 100%;
  position: absolute;
  top: 25px;
  right: -40px;
  display: flex;
  p {
    text-align: center;
    color: #fff;
  }
  .zh {
    width: 50%;
    height: 100%;
  }
  .en {
    width: 50%;
    height: 100%;
  }
}
.header {
  width: 100%;
  height: 80px;
  position: sticky;
  z-index: 55;
  top: 0;
  background: rgba(255, 255, 255, 1);
  box-shadow: 3px 4px 21px 0px rgba(70, 214, 177, 0.24);
  .head {
    position: relative;
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .logo {
      width: 188px;
      height: 63px;
      margin-right: 100px;
    }
    .head-left {
      display: flex;
      height: 100%;
      align-items: center;
      margin-left: 100px;
      margin-right: 100px;
      .nav {
        .head-text {
          cursor: pointer;
          margin: 0 10px;
          padding: 5px 20px;
          border-radius: 20px;
          font-size: 16px;
          transition: background 0.5s;
          color: rgba(78, 78, 78, 1);
          font-weight: 500;
          &:hover {
            background: #ff6c00;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue